import { render, staticRenderFns } from "./ApplicationsDetails.vue?vue&type=template&id=d94004d0&scoped=true"
import script from "./ApplicationsDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetails.vue?vue&type=style&index=0&id=d94004d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94004d0",
  null
  
)

export default component.exports